"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixFbox = fixFbox;
const tex_syntax_1 = require("./tex-syntax");
const fboxCommands = RegExp(`(\\\\fbox\\s*)(${(0, tex_syntax_1.block)(3)})`, "g");
function fixFbox(tex) {
    return tex.replace(fboxCommands, (_, command, arg) => {
        if (usesMathModeSyntax(arg) && !wrapsArgumentInDollarSigns(arg)) {
            return `${command.replace("fbox", "boxed")}${arg}`;
        }
        return `${command}${arg}`;
    });
}
function usesMathModeSyntax(tex) {
    return (/[_^]|\\dfrac|\\text/.test(tex) || new RegExp("\\\\" + tex_syntax_1.color).test(tex));
}
function wrapsArgumentInDollarSigns(block) {
    return block.startsWith("{$") && block.endsWith("$}");
}
